/* eslint-disable react/no-danger */
export const WaiverModalContent = ({ content }: any): JSX.Element => {
  return (
    <div className="CheckoutWaiver-Modal-content">
      {content && (
        <div
          className="popup-body"
          dangerouslySetInnerHTML={{ __html: content } /* // nosemgrep */}
        />
      )}
    </div>
  );
};
